<template>
  <div v-loading="optLoading" class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in tabList"
          :key="item.permissson"
          v-permissson="`${item.permissson}`"
          :class="['tabItem', active === $index ? 'active' : '']"
          @click="changeType($index, item.permissson)"
        >
          {{ item.name }}
          ({{ item.type === 10000 ? listTotal : tabTotal }})
        </span>
      </div>
      <div class="opt">
        <div
          v-if="filterList.invoiceDate && isActive"
          class="checkDate flex_c_c"
        >
          查询时间：{{
            filterList.invoiceDate[0] + "~" + filterList.invoiceDate[1]
          }}
        </div>
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="filterList.numbers"
            placeholder="请输入提单号/账单号/柜号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div
          v-show="computedPermissions('导出')"
          :v-permissson="computedPermissions('导出')"
          class="derive_a flex_c_c"
          @click="derive"
        >
          <img src="@/assets/images/bill/import.png" alt="" />
          导出
        </div>
        <div
          v-show="computedPermissions('生成账单')"
          v-if="tabActive === 2"
          :v-permissson="computedPermissions('生成账单')"
          class="derive_a flex_c_c"
          style="width: 100px"
          @click="dialogVisible3 = true"
        >
          生成账单
        </div>
        <div
          class="derive_a flex_c_c"
          style="padding: 0 12px"
          @click="dialogVisible4 = true"
        >
          自定义列表
        </div>
        <el-upload
          class="upload-demo"
          action="/api/Receivable/importReceivableValidate?type=0"
          :headers="headers"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="fileList"
          :show-file-list="false"
        >
          <div class="derive_a flex_c_c" style="width: 100px">
            <img src="@/assets/images/bill/upload.png" alt="" />
            导入模板
          </div>
        </el-upload>
        <div
          class="derive_a flex_c_c"
          style="width: 100px"
          @click="donwloadFile"
        >
          <img src="@/assets/images/bill/import.png" alt="" />
          下载模板
        </div>
        <BaseFilter
          :isActive="isActive"
          :width="486"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <div class="filter">
            <SelectFilter
              ref="selectFilter"
              :filterListJson="filterListJson"
              :filterListId="filterListId"
              :companyDrapdown="companyDrapdown"
              :pickUpOptions="pickUpOptions"
              :clearenceOptions="clearenceOptions"
              :originOptions="originOptions"
              :destinationOptions="destinationOptions"
              :userOptions="userOptions"
              :tableCode="tableCode"
              @ok="getFilter()"
            ></SelectFilter>
            <!-- <el-form ref="form" :model="filterList" label-width="100px">
              <el-form-item label="客户">
                <el-select
                  v-model="filterList.companyId"
                  style="width: 320px"
                  filterable
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务员">
                <el-select
                  v-model="filterList.saleIds"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                  multiple
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="杂费备注">
                <el-select
                  v-model="filterList.incidentalExpenses"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in incidentalExpensesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="账单日期">
                <el-date-picker
                  v-model="filterList.createdOn"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="到港日期">
                <el-date-picker
                  v-model="filterList.ataDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="清关放行日期">
                <el-date-picker
                  v-model="filterList.releaseDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="提柜日期">
                <el-date-picker
                  v-model="filterList.pickUpDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="还空日期">
                <el-date-picker
                  v-model="filterList.emptyReturnedDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="完结日期">
                <el-date-picker
                  v-model="filterList.finishDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-form> -->
          </div>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <el-tabs
        v-model="tabActive"
        v-loading="loading"
        type="border-card"
        class="el-tabs"
        @tab-click="initList()"
      >
        <template v-if="active">
          <el-tab-pane
            v-for="item in childTabList"
            :key="item.type"
            :label="`${item.name}(${
              item.type === 10000
                ? tabTotal
                : tabNumer.find((a) => a.type === item.type - 1)?.qty || 0
            })`"
            :name="item.type"
          >
          </el-tab-pane>
        </template>
        <BaseTable
          v-if="height !== 0"
          :key="active"
          :height="height"
          :tableData="{
            ...tableData,
            fileds,
          }"
          :pageSizes="[20, 30, 50, 100]"
          :pageIndex="pager.pageIndex"
          :pageSize="pager.pageSize"
          :loading="loading"
          :isEmptyBorder="true"
          @handlePageChange="handlePageChange"
          @handleSelectionChange="handleSelectionChange"
          @sortChange="sortChange"
          @dblclick="dblclick"
        >
          <template slot="blNo" slot-scope="row">
            {{ row.scope.blNo }}
            <img
              v-if="!row.scope.invoiceType"
              style="cursor: pointer"
              src="@/assets/images/const/viewBill.png"
              title="跟进记录"
              @click="viewlog(row.scope)"
            />
          </template>
          <template slot="importerName" slot-scope="row">
            {{ row.scope.importerName }}
            <span
              v-if="row.scope.importerName"
              class="tips-import"
              :class="!row.scope.importerPermission ? 'tips-owner' : 'tips-out'"
            >
              {{ !row.scope.importerPermission ? "内部" : "外部" }}
            </span>
          </template>
          <template slot="status" slot-scope="row">
            <!-- {{ row.scope.status | formatterStatus }} -->
                          <div v-if="row.scope.status === 0" class="status status1">
             {{ row.scope.status | formatterStatus }}
            </div>
            <div v-else-if="row.scope.status === 5" class="status status2">
             {{ row.scope.status | formatterStatus }}
            </div>
            <div v-else class="status status3">{{ row.scope.status | formatterStatus }}</div>
          </template>
          <template slot="opt" slot-scope="row">
            <el-popover
              v-show="active === 0"
              :ref="`popover${row.scope.id}`"
              placement="bottom-start"
              popper-class="pop-table-opt"
              width="114"
              trigger="click"
            >
              <div class="table-opt">
                <span
                  v-if="active === 0"
                  v-permissson="'entering'"
                  class="opt-item"
                  @click="entering(row.scope)"
                >录入</span
                >
              </div>
              <img
                slot="reference"
                style="margin-left: -14px"
                src="@/assets/images/table/opt.png"
              />
            </el-popover>
          </template>
          <template #custom-total>
            <div class="custom-total2">
              <div style="display: flex">
                <div class="select">已选 {{ selectionItem.length }} 项</div>
                <div
                  v-if="selectionItem.length && active === 0"
                  class="total"
                  v-html="totalHtml"
                ></div>
                <div
                  v-if="!selectionItem.length"
                  class="total"
                  style="margin-left: 10px"
                >
                  <div>
                    应收合计：<span>{{ receivableTotalAmount }} USD</span>
                  </div>
                  <template v-if="active === 0">
                    <div>
                      应付合计：<span>{{ payableTotalAmount }} USD</span>
                    </div>
                    <div>
                      利润合计：<span>{{ profitTotalAmount }} USD</span>
                    </div>
                  </template>
                  <div v-if="active && tabActive > 3 && tabActive !== 10000">
                    核销金额合计：<span>{{ verifedAmount }} USD</span>
                  </div>
                </div>
                <div
                  v-if="tabActive === 1"
                  v-permissson="'batchDeleteRow'"
                  class="batchCounterAudit flex_c_c"
                  @click="batchDeleteRow"
                >
                  <img src="@/assets/images/const/batchCounterAudit.png" />
                  批量删除
                </div>
                <div
                  v-if="tabActive === 1"
                  v-permissson="'batchCheck'"
                  class="batchCounterAudit flex_c_c"
                  @click="batchCheck"
                >
                  <img src="@/assets/images/const/batchCounterAudit.png" />
                  批量审核
                </div>
                <div
                  v-if="tabActive === 2"
                  v-permissson="'batchReCheck'"
                  class="batchCounterAudit flex_c_c"
                  @click="batchReCheck"
                >
                  <img src="@/assets/images/const/batchCounterAudit.png" />
                  批量反审核
                </div>
                <!-- <div
                v-if="active === 2"
                v-permissson="'batchFinished'"
                class="batchCounterAudit flex_c_c"
                @click="batchFinished(true)"
              >
                <img src="@/assets/images/const/batchCounterAudit.png" />
                批量完成
              </div>
              <div
                v-if="active === 3"
                v-permissson="'batchReFinished'"
                class="batchCounterAudit flex_c_c"
                @click="batchFinished(false)"
              >
                <img src="@/assets/images/const/batchCounterAudit.png" />
                批量取消完成
              </div> -->
              </div>
              <!-- <div class="select">已选 {{ selectionItem.length }} 项</div> -->
            </div>
          </template>
        </BaseTable>
      </el-tabs>
    </div>
    <ReceivablesDetailDialog
      :dialogVisible="dialogVisible1"
      :rowData="rowData"
      :status="active"
      @cancel="dialogVisible1 = false"
      @ok="ok"
    ></ReceivablesDetailDialog>
    <follow-up-records-drawer
      :drawer="drawer"
      :rowData="{
        ...rowData,
        id: rowData.mblId,
        status: 4,
      }"
      :bill-type="1"
      :showFinance="true"
      @close="drawer = false"
    ></follow-up-records-drawer>
    <UploadFileCheckDataDialog
      :dialogVisible="dialogVisible2"
      :fileData="fileData"
      @cancel="dialogVisible2 = false"
      @ok="
        dialogVisible2 = false;
        getList(pager);
      "
    ></UploadFileCheckDataDialog>
    <CreateBillDialog
      :dialogVisible="dialogVisible3"
      :type="0"
      :filterList="{
        ...formatterFilter(),
        status: active === 0 || tabActive === 10000 ? undefined : +tabActive - 1
      }"
      @cancel="dialogVisible3 = false"
      @ok="
        dialogVisible3 = false;
        getList(pager);
      "
    ></CreateBillDialog>
    <CustomerListDialog
      :dialogVisible="dialogVisible4"
      :useFildList="useFildListForTab"
      :useLogId="useLogId"
      :tabCode="tabCode"
      :tableCode="tableCode"
      @ok="dialogVisible4 = false; getUserUseLog()"
      @cancel="dialogVisible4 = false"
    ></CustomerListDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const FollowUpRecordsDrawer = () =>
  import('@/components/drawer/FollowUpRecordsDrawer')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
import ReceivablesDetailDialog from './components/ReceivablesDetailDialog'
import UploadFileCheckDataDialog from './components/UploadFileCheckDataDialog'
import CreateBillDialog from './components/CreateBillDialog'
const SelectFilter = () => import('@/components/filter/SelectFilter')
const CustomerListDialog = () =>
  import('@/components/dialog/CustomerListDialog.vue')
import {
  getReceivablePages,
  getReceivablePages1,
  completeReceivable,
  deleteReceivableInvoice,
  cancelReviewedReceivable,
  postReviewedReceivable,
  postDeleteReceivableInvoice,
  postCancelReviewedReceivable,
  postCompleteReceivable
} from '@/api/fee'
import { getSaleList, getSysTableUser } from '@/api/system'
import { permissions, derive } from '@/utils/common'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
import Decimal from 'decimal.js'
export default {
  name: 'Receivables',
  filters: {
    formatterStatus(val) {
      // 0 = NotEntry(未录入), 1 = Payable(应付已录), 2 = NotReviewed(未审核), 3 = Reviewed(已审核), 4 = Complete(已完成)
      return ['未录入', '应付已录', '未审核', '已审核', '已完成'][val]
    }
  },
  components: {
    BaseTable,
    BaseFilter,
    BaseMutiInput,
    ReceivablesDetailDialog,
    FollowUpRecordsDrawer,
    UploadFileCheckDataDialog,
    CreateBillDialog,
    CustomerListDialog,
    SelectFilter
  },
  mixins: [myMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      active: 0,
      tableData: {
        // fileds: [
        //   {
        //     filed: 'companyName',
        //     label: '客户',
        //     width: '220',
        //     align: 'left'
        //   },
        //   {
        //     filed: 'mblNo',
        //     label: '提单号',
        //     width: '220',
        //     align: 'left'
        //   },
        //   {
        //     filed: 'blNo',
        //     label: '分单号',
        //     width: '220',
        //     isCustom: true,
        //     align: 'left'
        //   },
        //   {
        //     filed: 'containerNumber',
        //     label: '柜号',
        //     width: '220',
        //     align: 'left'
        //   },
        //   {
        //     filed: 'feeName',
        //     label: '费用项',
        //     width: '220',
        //     align: 'left'
        //   },
        //   {
        //     filed: 'directCode',
        //     label: '直送仓库',
        //     width: '150'
        //   },
        //   {
        //     filed: 'isHold',
        //     label: '是否查验',
        //     width: '150',
        //     formatter: (row) => {
        //       return row.isHold ? '是' : '否'
        //     }
        //   },
        //   {
        //     filed: 'mblStatus',
        //     label: '提单状态',
        //     width: '150',
        //     formatter: (row) => {
        //       const obj = {
        //         0: '未完结',
        //         1: '未完结',
        //         3: '已完结',
        //         4: '已完结'
        //       }
        //       return obj[row.mblStatus] || '未完结'
        //     }
        //   },
        //   {
        //     filed: 'qty1',
        //     label: '数量',
        //     width: '80',
        //     isSort: true
        //   },
        //   {
        //     filed: 'unitPrice',
        //     label: '单价',
        //     width: '100',
        //     isSort: true
        //   },
        //   {
        //     filed: 'totalAmount',
        //     label: '金额',
        //     width: '100',
        //     isSort: true
        //   },
        //   {
        //     filed: 'picPickUpDate',
        //     label: '提柜时间',
        //     width: '160',
        //     formatter: (row) =>
        //       row.picPickUpDate
        //         ? row.picPickUpDate.slice(0, row.picPickUpDate.length - 9)
        //         : ''
        //   },
        //   {
        //     filed: 'firstDepartureDate',
        //     label: '出库时间',
        //     width: '160',
        //     formatter: (row) =>
        //       row.firstDepartureDate
        //         ? row.firstDepartureDate.slice(
        //             0,
        //             row.firstDepartureDate.length - 9,
        //           )
        //         : ''
        //   },
        //   {
        //     filed: 'supplierInvoiceDate',
        //     label: '账单日期',
        //     width: '180',
        //     isSort: true
        //   },
        //   {
        //     filed: 'remark',
        //     label: '备注',
        //     width: ''
        //   }
        // ],
        columns: [],
        total: 0,
        mutiCheck: true,
        mutiFixed: 'left'
      },
      loading: false,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      height: 0,
      // filterList: {
      //   numbers: '',
      //   companyId: '',
      //   saleIds: '',
      //   createdOn: '',
      //   ataDate: '',
      //   releaseDate: '',
      //   pickUpDate: '',
      //   emptyReturnedDate: '',
      //   finishDate: '',
      //   incidentalExpenses: 'all'
      // },
      isActive: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      drawer: false,
      rowData: {},
      selectionItem: [],
      userOptions: [],
      receivableTotalAmount: 0,
      payableTotalAmount: 0,
      profitTotalAmount: 0,
      verifedAmount: 0,
      tabNumer: [],
      tabTotal: 0,
      listTotal: 0,
      tabActive: 10000,
      tabList: [
        { name: '账单列表', permissson: 'ZDLB', type: 10000 },
        // { name: '未录入', permissson: 'WLR', type: 0 },
        // { name: '应付已录', permissson: 'YFYL', type: 1 },
        { name: '明细列表', permissson: 'MXLB', type: 0 }
      ],
      childTabList: [
        { name: '全部', type: 10000 },
        { name: '待审核', type: 1 },
        { name: '已审核', type: 2 },
        { name: '已完成', type: 3 },
        { name: '部分核销', type: 11 },
        { name: '已核销', type: 4 }
      ], // tab按钮权限
      incidentalExpensesOptions: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: true,
          label: '有'
        },
        {
          value: false,
          label: '无'
        }
      ],
      optLoading: false,
      fileData: [],
      referenceNumber: '',
      sortable: {},
      fileList: [],
      headers: {
        ESCLEARANCE: btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`)
      },
      activeCode: '',
      useFildList: [],
      useLogId: '',
      tableCode: 'Receivable',
      tabCode: 'ZDLB',
      filterList: {},
      filterListJson: [],
      filterListId: '',
      destinationOptions: [],
      originOptions: [],
      pickUpOptions: [],
      clearenceOptions: []
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    },
    useFildListForTab() {
      const arr = this.useFildList.filter(
        (a) =>
          a.selected === true &&
          (a.tabCode === this.tabCode || a.tabCode === null),
      )
      if (arr.length > 0) {
        return arr
      } else {
        // 说明是新加的tab 页面 且 没有用户习惯
        return this.useFildList
      }
    },
    companyOptions() {
      return this.companyDrapdown
    },
    totalHtml() {
      if (this.selectionItem.length === 0) {
        return ''
      }
      const arr1 = [] // 应收合计
      const arr2 = [] // 应付合计
      this.selectionItem.forEach((a) => {
        const item = arr1.find((n) => n.currency === a.currency)
        if (!item) {
          arr1.push({
            currency: a.currency,
            num: this.active === 0 ? a.receivableAmount : a.totalAmount
          })
        } else {
          item.num += +this.active === 0 ? a.receivableAmount : a.totalAmount
        }
        const item2 = arr2.find((n) => n.currency === a.currency)
        if (!item2) {
          arr2.push({
            currency: a.currency,
            num: a.payableAmount
          })
        } else {
          item2.num += +a.payableAmount
        }
      })
      const num1Arr = []
      const num2Arr = []
      let str1 = '&nbsp;&nbsp;应收合计：'
      arr1.forEach((a, index) => {
        num1Arr.push(a.num)
        str1 += `<span style="color: #fe453d;font-weight: bold;${
          index > 0 ? 'margin-left: 10px' : ''
        }"> ${a.num.toFixed(2)}  ${a.currency}</span>`
      })
      if (this.active === 0) {
        let str2 = '&nbsp;&nbsp;应付合计：'
        arr2.forEach((a, index) => {
          num2Arr.push(a.num)
          str2 += `<span style="
          color: #fe453d;font-weight: bold;${
            index > 0 ? 'margin-left: 10px' : ''
          }"> ${a.num.toFixed(2)}  ${a.currency}</span>`
        })
        let str3 = ''
        if (num1Arr.length > 0 && num2Arr.length > 0) {
          str3 = `&nbsp;&nbsp;利润合计：<span style="color: #fe453d;font-weight: bold;"> `
          num1Arr.forEach((a, index) => {
            str3 += `&nbsp;&nbsp;${
              (a - num2Arr[index]).toFixed(2) + arr1[index].currency
            }`
          })
          str3 += '</span>'
        }
        // const str3 = `&nbsp;&nbsp;利润合计：<span style="color: #fe453d;font-weight: bold;"> ${num1 + num2}</span>`
        return `${str1} ${str2} ${str3}`
      } else {
        return `${str1}`
      }
    },
    fileds() {
      const isCustomArr = ['blNo', 'status', 'importerName']
      const isSortArr = [
        'companyName',
        'eta',
        'ata',
        'releaseDate',
        'emptyReturnedDate',
        'dischargeDate',
        'finishDate',
        'pickUpdate',
        'firstDepartureDate',
        'qty',
        'weightCbm',
        'weightKgs',
        'taxesAmount',
        'receivableAmount',
        'payableAmount',
        'amountTax',
        'verifedAmount',
        'unpaidAmount',
        'createdOn',
        'reviewOn',
        'completeOn'
      ]
      const isCopy = ['mblNo', 'blNo', 'containerNumber']
      const isAlign = ['mblNo', 'blNo']
      const formatter = {
        eta: (row) => {
          return row.eta ? row.eta.slice(0, row.eta.length - 9) : ''
        },
        ata: (row) => {
          return row.ata ? row.ata.slice(0, row.ata.length - 9) : ''
        },
        emptyReturnedDate: (row) => {
          return row.emptyReturnedDate
            ? row.emptyReturnedDate.slice(0, row.emptyReturnedDate.length - 9)
            : ''
        },
        releaseDate: (row) => {
          return row.releaseDate
            ? row.releaseDate.slice(0, row.releaseDate.length - 9)
            : ''
        },
        dischargeDate: (row) => {
          return row.dischargeDate
            ? row.dischargeDate.slice(0, row.dischargeDate.length - 9)
            : ''
        },
        finishDate: (row) => {
          return row.finishDate
            ? row.finishDate.slice(0, row.finishDate.length - 9)
            : ''
        },
        pickUpdate: (row) => {
          return row.pickUpdate
            ? row.pickUpdate.slice(0, row.pickUpdate.length - 9)
            : ''
        },
        firstDepartureDate: (row) => {
          return row.firstDepartureDate
            ? row.firstDepartureDate.slice(0, row.firstDepartureDate.length - 9)
            : ''
        },
        clearenceType: (row) => row.clearenceTypeName || '',
        pickUpType: (row) => row.pickUpTypeName || '',
        isHold: (row) => (row.isHold ? '是' : '否'),
        mblStatus: (row) => {
          const obj = {
            0: '未完结',
            1: '未完结',
            3: '已完结',
            4: '已完结'
          }
          return obj[row.mblStatus] || '未完结'
        },
        weightKgs: (row) => {
          return row.weightKgs ? row.weightKgs + ' KG' : '0 KG'
        },
        weightCbm: (row) => {
          return row.weightCbm ? row.weightCbm + ' CBM' : '0 CBM'
        },
        receivableAmount: (row) => {
          return row.receivableAmount ? row.receivableAmount + ' USD' : '0 USD'
        },
        payableAmount: (row) => {
          return row.payableAmount ? row.payableAmount + ' USD' : '0 USD'
        },
        profitAmount: (row) => {
          return (
            new Decimal(row.receivableAmount || 0)
              .sub(new Decimal(row.payableAmount || 0))
              .toNumber() + ' USD'
          )
        },
        verifedAmount: (row) => {
          return row.verifedAmount ? row.verifedAmount + ' USD' : '0 USD'
        },
        unpaidAmount: (row) => {
          return row.unpaidAmount ? row.unpaidAmount + ' USD' : '0 USD'
        }
      }
      const newArr = this.useFildListForTab.map((item) => {
        return {
          filed: item.filed,
          label: item.label,
          width: item.width,
          isSort: isSortArr.indexOf(item.filed) > -1, // 是否支持过滤
          align: isAlign.indexOf(item.filed) > -1 && 'left',
          fixed: item.isFixed, // 是否固定 true, left, right
          isCustom: isCustomArr.indexOf(item.filed) > -1, // 是否自定义列显示
          isCopy: isCopy.indexOf(item.filed) > -1,
          formatter: formatter[item.filed] || undefined
        }
      })
      newArr.unshift({
        filed: 'opt',
        label: '',
        width: '50px',
        fixed: 'left',
        isCustom: true
      })
      return newArr
    }
  },
  created() {
    // if (!this.companyDrapdown.length) {
    //   this.$store.dispatch('getCompanyDrapdown')
    // }
  },
 async mounted() {
    this.height = document.querySelector('.data').offsetHeight - 64
    if (!this.$store.state.connect.connect.tabCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeList = ['ZDLB', 'MXLB']
      const childrenCode = menu.children.map((a) => a.code)
      this.active = codeList.findIndex((a) => childrenCode.includes(a)) || 0
      this.activeCode = menu.children[0].code
      // this.getList(this.pager)
      this.getUserUseLog()
      this.getUserList()
      this.getFilter()
    }
    if (!this.companyDrapdown.length) {
      await this.$store.dispatch('getCompanyDrapdown')
    }
    const pickUpOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 19 }
    )
    this.pickUpOptions = pickUpOptions
    const clearenceOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 18 }
    )
    this.clearenceOptions = clearenceOptions
    const destinationOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 1
    })
    this.destinationOptions = destinationOptions
    const originOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 0
    })
    this.originOptions = originOptions
  },
  methods: {
    async getUserUseLog() {
      try {
        this.loading = true
        // this.tableResData.columns = []
        const res = await getSysTableUser({
          tableCode: this.tableCode,
          tabCode: this.tabCode
        })
        if (res.success) {
          if (res.data && res.data.value) {
            await this.getList(this.pager)
            const filedArr = JSON.parse(res.data.value)
            this.useLogId = res.data.id
            this.useFildList = filedArr
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getFilter() {
      try {
        const res = await getSysTableUser({
          tableCode: this.tableCode,
          type: 1
        })
        if (res.success) {
          this.filterListJson = JSON.parse(res.data.value)
          this.filterListId = res.data.id
          console.log('filterListJson', this.filterListJson)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    changeType(type, code) {
      if (type) {
        this.height = document.querySelector('.data').offsetHeight - 103
        this.tabCode = 'MXLB'
      } else {
        this.height = document.querySelector('.data').offsetHeight - 64
        this.tabCode = 'ZDLB'
      }
      this.activeCode = code
      this.active = type
      this.receivableTotalAmount = 0
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getUserUseLog()
      // this.getList(param)
    },
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pager)
    },
    async getList(params) {
      try {
        this.loading = true
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            ...this.formatterFilter(),
                    status:
          this.active === 0 || this.tabActive === 10000
            ? undefined
            : +this.tabActive - 1
          }
        }
        let res

        if (this.active === 0) {
          res = await getReceivablePages(params)
        } else {
          res = await getReceivablePages1(params)
        }
        this.loading = false
        if (res.success) {
          res.data.list && (this.tableData.columns = res.data.list)
          this.tableData.total = res.data.total
            this.receivableTotalAmount = res.data.receivableTotalAmount
          if (this.active === 0) {
            this.payableTotalAmount = res.data.payableTotalAmount
            this.profitTotalAmount = res.data.profitTotalAmount
            this.listTotal = res.data.tabTotal
          } else {
            this.tabNumer = res.data.tabNumer
            this.tabTotal = res.data.tabTotal
            this.verifedAmount = res.data.verifedAmount
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    formatterFilter() {
      return this.filterList
      // const params = []
      // if (
      //   this.filterList.createdOn !== '' &&
      //   this.filterList.createdOn &&
      //   this.filterList.createdOn.length > 0
      // ) {
      //   params.push({
      //     type: 'CreateOn',
      //     start: this.filterList.createdOn[0],
      //     end: this.filterList.createdOn[1]
      //   })
      // }
      // if (
      //   this.filterList.releaseDate !== '' &&
      //   this.filterList.releaseDate &&
      //   this.filterList.releaseDate.length > 0
      // ) {
      //   params.push({
      //     type: 'ReleaseDate',
      //     start: this.filterList.releaseDate[0],
      //     end: this.filterList.releaseDate[1]
      //   })
      // }
      // if (
      //   this.filterList.ataDate !== '' &&
      //   this.filterList.ataDate &&
      //   this.filterList.ataDate.length > 0
      // ) {
      //   params.push({
      //     type: 'ATA',
      //     start: this.filterList.ataDate[0],
      //     end: this.filterList.ataDate[1]
      //   })
      // }
      // if (
      //   this.filterList.pickUpDate !== '' &&
      //   this.filterList.pickUpDate &&
      //   this.filterList.pickUpDate.length > 0
      // ) {
      //   params.push({
      //     type: 'PickUpDate',
      //     start: this.filterList.pickUpDate[0],
      //     end: this.filterList.pickUpDate[1]
      //   })
      // }
      // if (
      //   this.filterList.emptyReturnedDate !== '' &&
      //   this.filterList.emptyReturnedDate &&
      //   this.filterList.emptyReturnedDate.length > 0
      // ) {
      //   params.push({
      //     type: 'EmptyReturnedDate',
      //     start: this.filterList.emptyReturnedDate[0],
      //     end: this.filterList.emptyReturnedDate[1]
      //   })
      // }
      // if (
      //   this.filterList.finishDate !== '' &&
      //   this.filterList.finishDate &&
      //   this.filterList.finishDate.length > 0
      // ) {
      //   params.push({
      //     type: 'FinishDate',
      //     start: this.filterList.finishDate[0],
      //     end: this.filterList.finishDate[1]
      //   })
      // }
      // return {
      //    status: this.active === 0 || this.tabActive === 10000 ? undefined : +this.tabActive - 1,
      //   numbers:
      //     this.filterList.numbers.length > 0
      //       ? this.filterList.numbers
      //       : undefined,
      //   companyId:
      //     this.filterList.companyId !== '' &&
      //     this.filterList.companyId.length > 0
      //       ? this.filterList.companyId
      //       : undefined,
      //   saleIds:
      //     this.filterList.saleIds.length > 0
      //       ? this.filterList.saleIds
      //       : undefined,
      //   dateItems: params,
      //   // invoiceBeginDate:
      //   //   this.filterList.date !== ''
      //   //     ? this.filterList.invoiceDate[0]
      //   //     : undefined,
      //   // invoiceEndDate:
      //   //   this.filterList.date !== ''
      //   //     ? this.filterList.invoiceDate[1]
      //   //     : undefined,
      //   incidentalExpenses:
      //     this.filterList.incidentalExpenses !== 'all'
      //       ? this.filterList.incidentalExpenses
      //       : undefined
      // }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.getList(param)
    },
    sendFilter() {
      const filterList = this.$refs.selectFilter.getData()
      if (Object.keys(filterList).length > 0) {
        this.isActive = true
      }
      this.filterList = filterList
      // this.initList()
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.referenceNumber = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.getList(params)
      // if (
      //   this.filterList.numbers.length !== 0 ||
      //   this.filterList.createdOn !== '' ||
      //   this.filterList.ataDate !== '' ||
      //   this.filterList.releaseDate !== '' ||
      //   this.filterList.pickUpDate !== '' ||
      //   this.filterList.emptyReturnedDate !== '' ||
      //   this.filterList.finishDate !== '' ||
      //   this.filterList.saleIds !== '' ||
      //   this.filterList.companyId !== '' ||
      //   this.filterList.incidentalExpenses !== 'all'
      // ) {
      //   this.isActive = true
      // } else {
      //   this.isActive = false
      // }
      // const params = {
      //   pageIndex: 1,
      //   pageSize: 20
      // }
      // this.pager = params
      // this.getList(params)
    },
    reset() {
      this.$refs.selectFilter.reset()
      this.isActive = false
      this.referenceNumber = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
    },
    handlePageChange(page) {
      this.pager = page
      this.getList(page)
    },
    handleSelectionChange(items) {
      this.selectionItem = items
    },
    dblclick(row) {
      this.rowData = row
      if (this.active === 0) {
        this.dialogVisible1 = true
      }
    },
    // 录入
    entering(row) {
      this.rowData = row
      this.dialogVisible1 = true
    },
    // 详情
    detail(row) {
      if (this.active > 1) return
      this.rowData = row
      this.dialogVisible1 = true
    },
    // 完成
    async complete(row, type = true) {
      try {
        const result = await completeReceivable({
          id: row.id,
          completed: type
        })
        if (result.success) {
          this.getList(this.pager)
          this.$message.success(result.errorMessage)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    ok() {
      this.getList(this.pager)
    },
    // 导出
    async derive() {
      this.optLoading = true
      const params = {
        ...this.formatterFilter(),
                    status:
          this.active === 0 || this.tabActive === 10000
            ? undefined
            : +this.tabActive - 1,
        ids: this.selectionItem.map(item => item.id)
      }
      if (!this.active) {
        await derive('Receivable/exportReceivable', 'post', params)
      } else {
        await derive('Receivable/exportReceivable1', 'post', params)
      }
      this.optLoading = false
    },
    // 跟进记录
    viewlog(row) {
      this.drawer = true
      this.rowData = row
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.filterList.numbers = this.referenceNumber
        }
        this.$refs.popover.doClose()
        const param = {
          pageIndex: 1,
          pageSize: 20
        }
        this.pagerConfig = param
        this.getList(param)
      }, 0)
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.filterList.numbers = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    async deleteBill(row) {
      this.$confirm('要删除的记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const res = await deleteReceivableInvoice({ invoiceId: row.id })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success(res.errorMessage)
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.error(error)
        }
      })
    },
    batchDeleteRow() {
      if (this.selectionItem.length === 0) {
        this.$message.error('请选择要删除的记录')
        return
      }
      this.$confirm('要删除的记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const id = this.selectionItem.map((item) => item.id)
          const res = await postDeleteReceivableInvoice({
            ids: id,
            completed: true
          })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    unCheck(row) {
      this.$confirm('确定取消审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const res = await cancelReviewedReceivable({ invoiceId: row.id })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success('取消审核成功')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    batchReCheck() {
      if (this.selectionItem.length === 0) {
        this.$message.error('请选择要取消审核的记录')
        return
      }
      this.$confirm('确定取消审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const id = this.selectionItem.map((item) => item.id)
          const res = await postCancelReviewedReceivable({
            ids: id,
            completed: true
          })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success('取消审核成功')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    batchCheck() {
      if (this.selectionItem.length === 0) {
        this.$message.error('请选择要审核的记录')
        return
      }
      this.$confirm('确定审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const id = this.selectionItem.map((item) => item.id)
          const res = await postReviewedReceivable({
            ids: id,
            completed: true
          })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success('审核成功')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    batchFinished(completed = true) {
      if (this.selectionItem.length === 0) {
        this.$message.error(`请选择要${!completed ? '取消' : ''}完成的记录`)
        return
      }
      this.$confirm(`确定${!completed ? '取消' : ''}完成吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const id = this.selectionItem.map((item) => item.id)
          const res = await postCompleteReceivable({ ids: id, completed })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success(`${!completed ? '取消' : ''}完成成功`)
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    donwloadFile() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      const guid = '3a71c69cd7a84aa484796cd31dbbeb87'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=${guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    handleError(error) {
      this.$message.error(error)
      this.fileList = []
    },
    handleSuccess(res) {
      if (res.success) {
        this.fileList = []
        this.$message.success('导入成功')
        this.fileData = res.data
        this.dialogVisible2 = true
      } else {
        this.$message.error(res.errorMessage)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .tips-import {
    position: absolute;
    display: inline-block;
    width: auto;
    height: 20px;
    padding: 0 10px;
    font-size: 12px;
    line-height: 20px;
    top: 0;
    left: 0;
  }
  .tips-owner {
    color: rgba(53, 186, 131, 1);
    background: rgba(53, 186, 131, 0.1);
  }
  .tips-out {
    color: rgba(254, 69, 61, 1);
    background: rgba(254, 69, 61, 0.1);
  }
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: rgb(18, 88, 188);
    }
  }
  .opt {
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      color: #2c3e50;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .derive_a {
      min-width: 80px;
      background: rgb(18, 88, 188);
      height: 30px;
      box-sizing: border-box;
      margin-right: 5px;
      border-radius: 4px;
      cursor: pointer;
    }
    .derive_b {
      width: 120px;
      border: 1px solid rgb(18, 88, 188);
      color: rgb(18, 88, 188);
      height: 30px;
      box-sizing: border-box;
      margin-right: 5px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .status {
      display: inline-block;
      width: auto;
      padding: 0 12px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      border-radius: 4px 4px 4px 4px;
    }
    .status1 {
      color: #feaa4f;
      background: rgba(254, 170, 79, 0.1);
    }
    .status2 {
      color: #ff7444;
      background: rgba(255, 116, 68, 0.1);
    }
    .status3 {
      color: #35ba83;
      background: rgba(53, 186, 131, 0.1);
    }
  }
  .custom-total1 {
    position: absolute;
    left: 0;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
  .custom-total2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    height: 40px;
    width: auto;
    background: #f7f7f7;
    border: 1px solid #eeeeee;
    line-height: 40px;
    border-top: 0;
    padding-left: 17px;
    padding-right: 40px;
    box-sizing: border-box;
    z-index: 2;
    .select {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
    .total {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      color: #333333;
      span {
        color: #fe453d;
        font-weight: bold;
      }
      div + div {
        margin-left: 20px;
      }
    }
    .batchCounterAudit {
      width: 120px;
      height: 30px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #33c481;
      cursor: pointer;
      box-sizing: border-box;
      margin-left: 5px;
      margin-top: 5px;
      border-radius: 2px 2px 2px 2px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #33c481;
    }
  }
  .table-opt {
    display: flex;
    justify-content: space-around;
    span {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
      & + span {
        margin-left: 20px;
      }
    }
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
